import { render, staticRenderFns } from "./WorkflowsListPage.vue?vue&type=template&id=87740a84&scoped=true"
import script from "./WorkflowsListPage.vue?vue&type=script&lang=js"
export * from "./WorkflowsListPage.vue?vue&type=script&lang=js"
import style0 from "./WorkflowsListPage.vue?vue&type=style&index=0&id=87740a84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87740a84",
  null
  
)

export default component.exports